import React from 'react';
import { animated, useSpring, type SpringValues } from '@react-spring/web';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { Box } from '@mentimeter/ragnar-ui/box';

interface FadeInProps extends BoxT {
  delay?: number;
}

export const FadeIn = ({
  delay = 0,
  children,
  ...restProps
}: React.PropsWithChildren<FadeInProps>) => {
  const [springs] = useSpring(() => ({
    from: { opacity: 0 },
    to: [{ opacity: 1 }],
    delay,
  }));

  return (
    <Box as={animated.div} style={springs as SpringValues} {...restProps}>
      {children}
    </Box>
  );
};
